/* eslint-disable */
import $ from 'jquery';
require('normalize.css/normalize.css');
require('../css/main.scss');
require('./page.scss');
import Cookies from 'js-cookie';
import 'regenerator-runtime/runtime';
import { db, getDoc, doc, auth, registerUser, getCompanyByName, createCompany, serverTimestamp, signInWithEmailAndPassword, sendPasswordResetEmail, updateDoc, setPersistence, browserLocalPersistence } from '../js/firebaseConfig';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

function getFriendlyErrorMessage(errorCode) {
  switch (errorCode) {
    case 'auth/invalid-email':
      return 'Invalid email address.';
    case 'auth/invalid-credential':
      return 'Invalid email address or password.';
    case 'auth/user-disabled':
      return 'This user account has been disabled.';
    case 'auth/user-not-found':
      return 'No user found with this email address.';
    case 'auth/wrong-password':
      return 'Incorrect password.';
    case 'auth/email-already-in-use':
      return 'Email address is already in use.';
    case 'auth/weak-password':
      return 'The password is too weak.';
    case 'auth/too-many-requests':
      return 'Too many login attempts. Please try again later.';
    default:
      return 'An error occurred. Please try again.';
  }
}

$(document).ready(function() {
  async function fetchCompanyName(companyId) {
    if (!companyId) return 'N/A';
    try {
        const companyDoc = await getDoc(doc(db, 'companies', companyId));
        const companyData = companyDoc.data();
        return companyDoc.exists() ? companyData.name : 'N/A';
    } catch (error) {
        console.error('Error fetching company name:', error);
        return 'N/A';
    }
  }

  async function loginUser(user) {
    try {
        const userDocRef = doc(db, 'users', user.uid);
        const userDoc = await getDoc(userDocRef);
        const userData = userDoc.data();
        const companyId = userData.companyId;
        const companyDoc = await getDoc(doc(db, 'companies', companyId));
        const companyData = companyDoc.data();
        const companyName = companyData.name;
        var companyLanguage = companyData.language;
        if(companyLanguage == 'FR'){
          companyLanguage = '1';
        }
        if(companyLanguage == 'EN'){
          companyLanguage = '2';
        }
        if(companyLanguage == 'ES'){
          companyLanguage = '3';
        }
        if(companyLanguage == 'IT'){
          companyLanguage = '4';
        }
        if(companyLanguage == 'PT'){
          companyLanguage = '5';
        }
        const nameParts = userData.name.split(' ');
        const firstName = nameParts[0];
        const lastName = nameParts.slice(1).join(' ');
  
        const password = $('#password').val();

        setCookie(user, companyId);
    } catch (error) {
        console.error('Error logging in user:', error);
    }
  }

  function setCookie(user, companyId){
    // Redirection après login
    Cookies.set('userMail', user.email);
    Cookies.set('companyId', companyId);
    if (user.email === 'contact@oliverlist.com') {
        Cookies.set('admin', 'true');
    }
    if (user.email === 'jean-francois.maniere@salesridge.co' || user.email === 'roeum.mak@salesridge.co' || user.email === 'paul.bouche@salesridge.co' || user.email === 'dany.hammoum@salesridge.co' || user.email === 'waldertully.385920@gmail.com' || user.email === 'margaeryfrey.325319@gmail.com' || user.email === 'aerystarly.838561@gmail.com' || user.email === 'thibault.debecdelievre@oliverlist.com') {
        Cookies.set('trainer', 'true');
    }
    console.log('redirect');
    window.location.href = 'dashboard.html';
  }

  $('#loginForm').on('submit', async function(event) {
    event.preventDefault();
    
    const email = $('#email').val();
    const password = $('#password').val();
    
    try {
      // S'assurer que la persistance est bien configurée avant la connexion
      await setPersistence(auth, browserLocalPersistence);
      console.log('✅ [Login] Persistance LOCAL configurée');
      
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      // Logger les infos de connexion
      console.log('✅ [Login] Connexion réussie pour:', user.email);
      
      loginUser(user);
    } catch (error) {
      console.log(error.code);
      const friendlyMessage = getFriendlyErrorMessage(error.code);
      console.error('❌ [Login] Erreur de connexion:', error);
      alert(friendlyMessage);
    }
  });

  $('#forgotPassword').on('click', async function() {
    const email = $('#email').val();
    
    if (!email) {
      alert('Veuillez entrer votre adresse email.');
      return;
    }
    
    try {
      await sendPasswordResetEmail(auth, email);
      alert('Email de réinitialisation de mot de passe envoyé ! Veuillez vérifier votre boîte de réception.');
    } catch (error) {
      const friendlyMessage = getFriendlyErrorMessage(error.code);
      console.error('Error sending password reset email: ', error);
      alert(friendlyMessage);
    }
  });
});